import React from "react"
import { useLocation } from "react-router-dom"
import { useAuthContext } from "contexts/AuthContext"
import { routes } from "common/navigationRoutes"
import { isRunningFromIframe } from "common/functions"
import { StudentLayoutUI } from "./StudentLayout.ui"

export const StudentLayoutView = () => {
  const { isConfigurationCompleted } = useAuthContext()
  const location = useLocation()

  const isActivityRoute =
    location.pathname
      ?.toLocaleLowerCase()
      .startsWith(routes.ACTIVITY?.toLocaleLowerCase()) ||
    location.pathname
      ?.toLocaleLowerCase()
      .startsWith("/v2" + routes.ACTIVITY?.toLocaleLowerCase()) ||
    location.pathname
      ?.toLocaleLowerCase()
      .startsWith(routes.CHOOSE_GAMES?.toLocaleLowerCase()) ||
    location.pathname
      ?.toLocaleLowerCase()
      .startsWith("/v2" + routes.CHOOSE_GAMES?.toLocaleLowerCase())

  const runningFromIframe = isRunningFromIframe()
  const hasParamFirstSetup = new URLSearchParams(location.search).get(
    "firstSetup"
  )

  const hideNavigation =
    isActivityRoute ||
    runningFromIframe ||
    hasParamFirstSetup ||
    !isConfigurationCompleted

  return <StudentLayoutUI hideNavigation={hideNavigation} />
}
